export function auth() {
    return {
        headers: {
            Authorization: `Token ${localStorage.token}`,
        },
    }
}

let permissions

export function checkPermission(permission) {
    if (!permissions) {
        permissions = JSON.parse(localStorage.getItem('permissions'))
    }

    return permissions.includes(permission)
}


export function clearPermissions() {
    permissions = undefined
}

/* function redirectPage(groups) {
    // eslint-disable-next-line no-restricted-syntax
    for (const group of groups) {
        if (group === 'admin') return '/statistics/finance'
        if (group === 'seller') return '/project/projects'
        if (group === 'developer' || group === 'team_lead') return '/tasks/projects'
        if (group === 'accountant') return '/finance/wallet'
        if (group === 'hr') return '/staff/employee'
    }
    return '/tasks/projects'
} */
function redirectPage(groups) {
    // eslint-disable-next-line no-restricted-syntax
    for (const group of groups) {
        if (group === 'admin') return '/manthly/rotation'
        if (group === 'seller') return '/manthly/rotation'
        if (group === 'developer' || group === 'team_lead') return '/manthly/rotation'
        if (group === 'accountant') return '/manthly/rotation'
        if (group === 'hr') return '/manthly/rotation'
    }
    return '/manthly/rotation'
}

export function signin({ user, token, permissions: userPermissions, groups }, history) {
    localStorage.setItem('user', JSON.stringify(user))
    localStorage.setItem('token', token)
    localStorage.setItem('permissions', JSON.stringify(userPermissions))
    history.push(redirectPage(groups))
}

export function signOut(history) {
    localStorage.removeItem('user')
    localStorage.removeItem('token')
    localStorage.removeItem('permissions')
    clearPermissions()
    history.push('/')
}

export function isAuthenticated() {
    return localStorage.getItem('user')
        && localStorage.getItem('token')
        && localStorage.getItem('permissions')
}
